export function addWatchedOperationId(
  current: ReadonlySet<string>,
  operationId: string,
): Set<string> {
  if (current.has(operationId)) {
    return new Set(current)
  }

  return new Set([...current, operationId])
}

export function removeWatchedOperationId(
  current: ReadonlySet<string>,
  operationId: string,
): Set<string> {
  if (!current.has(operationId)) {
    return new Set(current)
  }

  const next = new Set(current)
  next.delete(operationId)
  return next
}

export function hasWatchedOperations(watchedIds: ReadonlySet<string>): boolean {
  return watchedIds.size > 0
}
